module.exports = __webpack_public_path__ + "img/teledental.58479623.png";